import React from 'react'
import { FaEyeSlash } from 'react-icons/fa';

const Fullname = (props) => {
    const [mask, setMask] = React.useState(false)

    const formatName = (fullName) => {
        if (!fullName) return "";

        const parts = fullName.trim().split(" ");
        if (parts.length === 1) return parts[0]; // só tem primeiro nome

        const first = parts[0];
        const second = parts[1] || "";

        // mantém as 2 primeiras letras e troca o resto por "*"
        const maskedSecond =
            second.slice(0, 2) + "*".repeat(Math.max(0, second.length - 2));

        return `${first} ${maskedSecond}`;
    }

    return (
        <span className="d-block pointer mb-2 bs-color" onClick={() => (mask || props.enabled) && setMask(mask ? false : true)}>
        {(mask) ? props.fullName : <> {formatName(props.fullName)} <FaEyeSlash onClick={() => setMask(mask ? false : true)} className="ms-2" /></>}
        </span>
    )
}

export default Fullname